//src/redux/services/store/storePagesApi.ts
import type { EndpointBuilder } from "@reduxjs/toolkit/query";
import { baseApi } from "../baseApi";

export type StoreSectionItem = {
  id: number;
  section_id: number;
  slot: string | null;
  sort_order: number;
  is_active: boolean;
  content_json: Record<string, any>;
  created_at?: string;
  updated_at?: string;
};

export type StoreSection = {
  id: number;
  page_slug: string;
  section_type: string;
  title?: string | null;
  sort_order: number;
  is_active: boolean;
  settings_json?: Record<string, any> | null;
  data_source_json?: Record<string, any> | null;
  created_at?: string;
  updated_at?: string;
  items?: StoreSectionItem[];
};

export type StorePageResponse = {
  page_slug: string;
  sections: StoreSection[];
};

type Builder = EndpointBuilder<any, any, any>;

export const storePagesApi = baseApi.injectEndpoints({
  endpoints: (builder: Builder) => ({
    getStorePage: builder.query<
      StorePageResponse,
      { pageSlug: string; includeItems?: boolean; activeOnly?: boolean }
    >({
      query: ({ pageSlug, includeItems = true, activeOnly = true }) => ({
        url: `/store/pages/${encodeURIComponent(pageSlug)}`,
        params: {
          include_items: includeItems,
          active_only: activeOnly,
        },
        method: "GET",
      }),
      providesTags: (_result: StorePageResponse | undefined, _err: unknown, arg) => [
        { type: "StorePage", id: arg.pageSlug },
      ],
    }),
  }),
  overrideExisting: false,
});

export const { useGetStorePageQuery } = storePagesApi;